/* global axios */
import ApiClient from '../../ApiClient';

class VoiceAPI extends ApiClient {
  constructor() {
    super('voice', { accountScoped: true });
  }

  getToken(inboxId) {
    if (!inboxId) return Promise.reject(new Error('Inbox ID is required'));
    return axios
      .post(`${this.baseUrl()}/inboxes/${inboxId}/voice_token`)
      .then(r => r.data);
  }

  // OSS Twilio Voice methods
  initiateVoiceCall(inboxId, contactId, conversationId = null) {
    return axios
      .post(`${this.baseUrl()}/voice_calls`, {
        inbox_id: inboxId,
        contact_id: contactId,
        conversation_id: conversationId,
      })
      .then(r => r.data);
  }

  endVoiceCall(callId) {
    return axios
      .post(`${this.baseUrl()}/voice_calls/${callId}/end_call`)
      .then(r => r.data);
  }

  getActiveVoiceCalls() {
    return axios
      .get(`${this.baseUrl()}/voice_calls/active`)
      .then(r => r.data);
  }

  // Conference-bridge model: first agent to join wins the call. Returns the
  // conference handle the browser softphone connects to.
  joinConference({ conversationId, inboxId, callSid }) {
    return axios
      .post(`${this.baseUrl()}/voice_calls/join_conference`, {
        call_sid: callSid,
        inbox_id: inboxId,
        conversation_id: conversationId,
      })
      .then(r => r.data);
  }

  leaveConference({ callSid }) {
    return axios
      .post(`${this.baseUrl()}/voice_calls/leave_conference`, {
        call_sid: callSid,
      })
      .then(r => r.data);
  }

  // Warm/cold agent-to-agent transfer within the call's conference.
  transferCall({ callSid, toAgentId, mode = 'warm' }) {
    return axios
      .post(`${this.baseUrl()}/voice_calls/transfer`, {
        call_sid: callSid,
        to_agent_id: toAgentId,
        mode,
      })
      .then(r => r.data);
  }
}

export default new VoiceAPI();
